// Header navigation: the full-bleed mega menu (GSAP clip-path panel + accordion
// sub-panes). The static header variant ships its own Webflow interaction, so
// this bails out when that variant is on the page.
export function initNavMenu() {
  if (document.querySelector('.header[data-wf--header--variant="static"]')) return;
  const g = window.gsap,
    t = document.querySelector('.nav-menu'),
    hdr = document.querySelector('.header');
  if (!g || !t || !hdr) return;
  const q = (s) => t.querySelector(s),
    dd = q('.nav-menu__dropdown'),
    toggles = [...hdr.querySelectorAll('[data-nav-toggle]')],
    panes = [...t.querySelectorAll('[data-nav-pane]')],
    burger = document.querySelector('.navbar__menu'),
    openers = [...document.querySelectorAll('[data-nav-open]')],
    outsides = burger ? [burger, ...openers] : [...openers],
    hoverOK = matchMedia('(hover:hover)').matches,
    wide = () => matchMedia('(min-width: 992px)').matches;
  matchMedia('(prefers-reduced-motion)').matches && g.globalTimeline.timeScale(1e3);
  let panelOpen = 0,
    subOpen = 0,
    hoverMode = 0,
    opener = 0,
    closedAt = 0,
    pane = '';
  const EASE = 'expo.inOut',
    OPEN_EASE = 'expo.out',
    EXIT_EASE = 'power1.in',
    EXIT_D = 0.32,
    CLIP = 'inset(0% 0% 100% 0%)';
  g.set(t, { clipPath: CLIP });
  const tw = (el, v) => {
      g.killTweensOf(el);
      g.to(el, v);
    },
    rise = (els, y, d, st, dl) => g.fromTo(els, { y, autoAlpha: 0 }, { y: 0, autoAlpha: 1, duration: d, ease: 'power3', stagger: st, delay: dl, clearProps: 'transform' }),
    aria = (el, v) => el && el.setAttribute('aria-expanded', v ? 'true' : 'false'),
    topOf = () => {
      const hr = hdr.getBoundingClientRect();
      let b = hr.bottom;
      document.querySelectorAll('[data-header-block]').forEach((m) => {
        const r = m.getBoundingClientRect();
        if (r.height && r.bottom > b) b = r.bottom;
      });
      hdr.style.setProperty('--nav-open-top', Math.max(0, b) + 'px');
      hdr.style.setProperty('--nav-hdr-h', hr.height + 'px');
    },
    setPane = (n) => {
      pane = n;
      panes.forEach((p) => p.classList.toggle('is-active', p.getAttribute('data-nav-pane') === n));
      toggles.forEach((x) => {
        const on = x.getAttribute('data-nav-toggle') === n;
        x.classList.toggle('is-open', on);
        aria(x, on);
      });
    },
    openSub = (n) => {
      if (subOpen && pane === n) return;
      const was = subOpen;
      subOpen = 1;
      setPane(n);
      const items = t.querySelectorAll('.nav-menu__pane.is-active .nav-menu__item, .nav-menu__dropdown > .nav-menu__list .nav-menu__item');
      if (was) {
        rise(items, 24, 0.4, 0.05, 0);
      } else {
        tw(dd, { height: 'auto', duration: 0.6, ease: OPEN_EASE });
        rise(items, 32, 0.5, 0.07, 0.08);
      }
    },
    closeSub = (instant) => {
      if (!subOpen) return;
      subOpen = 0;
      pane = '';
      toggles.forEach((x) => {
        x.classList.remove('is-open');
        aria(x, 0);
      });
      const unmount = () => subOpen || panes.forEach((p) => p.classList.remove('is-active'));
      if (instant) {
        unmount();
        tw(dd, { height: 0, duration: 0 });
      } else {
        tw(dd, { height: 0, duration: 0.5, ease: EASE, onComplete: unmount });
        tw(t.querySelectorAll('.nav-menu__item'), { y: 24, opacity: 0, duration: 0.3 });
      }
    },
    openPanel = (el) => {
      panelOpen = 1;
      opener = el;
      aria(el, 1);
      hdr.classList.add('is-menu-open');
      t.classList.add('is-open');
      topOf();
      matchMedia('(min-width: 768px) and (max-width: 991px)').matches && !subOpen && openSub('work');
      t.style.visibility = 'visible';
      tw(t, { clipPath: 'inset(0% 0% 0% 0%)', duration: 0.7, ease: OPEN_EASE });
    },
    closePanel = (refocus) => {
      panelOpen = 0;
      hoverMode = 0;
      closedAt = Date.now();
      opener && aria(opener, 0);
      const drop = () => {
        if (panelOpen) return;
        hdr.classList.remove('is-menu-open');
        t.classList.remove('is-open');
        t.style.visibility = 'hidden';
      };
      tw(t, { clipPath: CLIP, duration: EXIT_D, ease: EXIT_EASE, onComplete: drop });
      closeSub(0);
      t.querySelectorAll('.nav-menu__acc-row.is-open').forEach((r) => r.classList.remove('is-open'));
      refocus && opener && opener.focus();
    };
  burger &&
    burger.addEventListener('click', (e) => {
      e.preventDefault();
      panelOpen ? closePanel(1) : openPanel(burger);
    });
  openers.forEach((el) => {
    const v = el.getAttribute('data-nav-open');
    hoverOK &&
      el.addEventListener('mouseenter', () => {
        if (!panelOpen && Date.now() - closedAt > 900) {
          hoverMode = 1;
          openPanel(el);
          v !== 'menu' && openSub(v);
        }
      });
    el.addEventListener('click', (e) => {
      if (!hoverOK) {
        e.preventDefault();
        panelOpen ? closePanel(0) : (openPanel(el), v !== 'menu' && openSub(v));
      }
    });
  });
  toggles.forEach((el) => {
    const v = el.getAttribute('data-nav-toggle');
    if (hoverOK) {
      el.addEventListener('mouseenter', () => panelOpen && openSub(v));
      el.addEventListener('focus', () => panelOpen && openSub(v));
    }
    el.addEventListener('click', (e) => {
      if (el.closest('.nav-menu__tab-links') || (!hoverOK && !el.hasAttribute('data-nav-open'))) {
        e.preventDefault();
        subOpen && pane === v ? closeSub(0) : openSub(v);
      }
    });
  });
  hdr.querySelectorAll('.header__bar .navbar-alt__links a:not([data-nav-toggle])').forEach((el) => {
    el.addEventListener('mouseenter', () => {
      closeSub(0);
    });
  });
  hdr.querySelectorAll('[data-nav-close]').forEach((el) =>
    el.addEventListener('click', (e) => {
      e.preventDefault();
      closePanel(0);
    }),
  );
  t.querySelectorAll('[data-acc]').forEach((el) =>
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const row = el.closest('.nav-menu__acc-row'),
        on = row.classList.toggle('is-open');
      on &&
        t.querySelectorAll('.nav-menu__acc-row.is-open').forEach((r) => {
          if (r === row) return;
          r.classList.remove('is-open');
          const a = r.querySelector('[data-acc]');
          a && aria(a, 0);
        });
      aria(el, on);
    }),
  );
  hdr.addEventListener('mouseleave', () => {
    hoverOK && (hoverMode ? closePanel(0) : closeSub(0));
  });
  document.addEventListener(
    'click',
    (e) => {
      !panelOpen || hdr.contains(e.target) || outsides.some((x) => x.contains(e.target)) || closePanel(0);
    },
    true,
  );
  document.addEventListener('keydown', (e) => {
    panelOpen && 'Escape' === e.key && closePanel(1);
  });
  document.addEventListener('navform:close', () => {
    closedAt = Date.now();
  });
  const remeasure = () => {
    panelOpen && topOf();
  };
  addEventListener('resize', remeasure);
  addEventListener('scroll', remeasure, { passive: true });
}
